import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DeclineProposal } from '../modules/ComponentsLibrary/ServiceCall/components/DeclineProposal';

export const Route = createFileRoute('/decline-proposal/$token')({
  component: RouteComponent,
  params: z.object({
    token: z.string().min(1),
  }),
  head: () => ({
    meta: [
      {
        title: 'Decline Proposal',
      },
    ],
  }),
});

function RouteComponent() {
  const { token } = Route.useParams();

  return (
    <div className="min-h-screen bg-gray-50">
      <DeclineProposal token={token} />
    </div>
  );
}
